import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
// import DeleteIcon from "@mui/icons-material/Delete";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import React, { useState } from "react";
import useDetailInvoice from "../../services/queries/useDetailInvoice";
import ModalDetailInvoice from "../ModalDetailInvoice/ModalDetailInvoice";
import ModalRevertInvoice from "../ModalRevertInvoice/ModalRevertInvoice";
import Button from "@mui/material/Button";
import toRupiahDesimal from "../../utils/toRupiahDesimal";
import ModalDeletePreOrder from "../ModalDeletePreOrder/ModalDeletePreOrder";
import ModalAccPO from "../ModalAccPO/ModalAccPO";
import useDetailInvoicePO from "../../services/queries/useDetailInvoicePO";

interface ICardInvoiceProps {
    detailInvoiceId: number;
    noInvoice: string;
    tanggalInvoice: string;
    uangYangDibayar: number;
    isReverted: number;
    customer: {
        id: number | null;
        nama: string | null;
    };
    ongkir: string | null;
    ketOngkir: string | null;
    customAmount: string | null;
    ketCustomAmount: string | null;
    refetchListInvoice: () => void;
    metode: string | null;
    sisaHutang: number;
    jatuhTempo: string | null;
    hargaPenjualan: number;
    metodePelanggan: string | null;
    metodeId: number;
    isPO?: boolean;
    status?: number;
}

const CardInvoice = ({
    detailInvoiceId,
    noInvoice,
    tanggalInvoice,
    uangYangDibayar,
    isReverted,
    customer,
    ongkir,
    ketOngkir,
    customAmount,
    ketCustomAmount,
    metodePelanggan,
    refetchListInvoice,
    metode,
    sisaHutang,
    jatuhTempo,
    hargaPenjualan,
    metodeId,
    isPO,
    status,
}: ICardInvoiceProps) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));
    const [isOpenModalRevertInvoice, setIsOpenModalRevertInvoice] =
        useState(false);
    const [isOpenModalDetailInvoice, setIsOpenModalDetailInvoice] =
        useState(false);
    const [isOpenModalDetailInvoicePO, setIsOpenModalDetailInvoicePO] =
        useState(false);
    const [isOpenModalDeletePreOrder, setIsOpenModalDeletePreOrder] =
        useState(false);
    const [isOpenModalAccPO, setIsOpenModalAccPO] = useState(false);
    const { data: detailInvoice, status: statusDetailInvoice } =
        useDetailInvoice(detailInvoiceId);
    const { data: detailInvoicePO, status: statusDetailInvoicePO } =
        useDetailInvoicePO(detailInvoiceId);

    const closeModalDetailInvoice = () => {
        setIsOpenModalDetailInvoice(false);
    };

    const closeModalDetailInvoicePO = () => {
        setIsOpenModalDetailInvoicePO(false);
    };

    const openModalDeletePreOrder = () => {
        setIsOpenModalDeletePreOrder(true);
    };

    const closeModalDeletePreOrder = () => {
        setIsOpenModalDeletePreOrder(false);
    };

    const openModalAccPO = () => {
        setIsOpenModalAccPO(true);
    };

    const closeModalAccPO = () => {
        setIsOpenModalAccPO(false);
    };

    return (
        <React.Fragment>
            <Card
                variant="outlined"
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 1,
                    padding: isTabletScreen ? 1 : 2,
                }}
            >
                <Box>
                    <Typography fontWeight="bold">{noInvoice}</Typography>
                    <Typography fontSize={12} color="#76747C">
                        {tanggalInvoice}
                    </Typography>
                    <Typography
                        marginTop={1}
                        fontSize={12}
                        fontWeight="bold"
                        color="#76747C"
                    >
                        {isPO
                            ? "Pre Order"
                            : isReverted
                            ? "Void invoice"
                            : hargaPenjualan < 0
                            ? "Bukti void"
                            : metode === "Piutang Usaha"
                            ? `Piutang: ${toRupiahDesimal(sisaHutang)}`
                            : `${metode}: ${toRupiahDesimal(uangYangDibayar)}`}
                    </Typography>
                </Box>
                <Stack direction="row" spacing={2}>
                    <Button
                        variant="contained"
                        onClick={() => {
                            if (isPO) {
                                setIsOpenModalDetailInvoicePO(true);
                            } else {
                                setIsOpenModalDetailInvoice(true);
                            }
                        }}
                        size="small"
                        color="buttongreen"
                        disableElevation
                        sx={{
                            minWidth: "unset",
                            padding: "8px",
                            width: "32px",
                            height: "32px",
                        }}
                    >
                        <VisibilityIcon
                            sx={{ width: "16px", height: "16px" }}
                        />
                    </Button>
                    {isPO && (
                        <Button
                            disabled={status === 1}
                            variant="contained"
                            onClick={() => {
                                openModalAccPO();
                            }}
                            size="small"
                            color="buttonblue"
                            disableElevation
                            sx={{
                                minWidth: "unset",
                                padding: "8px",
                                width: "32px",
                                height: "32px",
                            }}
                        >
                            <ReceiptLongIcon
                                sx={{ width: "16px", height: "16px" }}
                            />
                        </Button>
                    )}
                    {isPO && (
                        <Button
                            disabled={status === 1}
                            variant="contained"
                            onClick={() => {
                                openModalDeletePreOrder();
                                // setIsOpenModalRevertInvoice(true);
                            }}
                            size="small"
                            color="buttonyellow"
                            disableElevation
                            sx={{
                                minWidth: "unset",
                                padding: "8px",
                                width: "32px",
                                height: "32px",
                                // visibility:
                                //     params.row.hargaPenjualan > 0 &&
                                //     params.row.isReverted === 0
                                //         ? "hidden"
                                //         : undefined,
                            }}
                        >
                            <DeleteIcon
                                sx={{ width: "16px", height: "16px" }}
                            />
                        </Button>
                    )}
                    {/* {uangYangDibayar > 0 && isReverted === 0 && (
                        <IconButton
                            onClick={() => {
                                setIsOpenModalRevertInvoice(true);
                            }}
                        >
                            <DeleteIcon />
                        </IconButton>
                    )} */}
                </Stack>
            </Card>
            {detailInvoice && (
                <ModalDetailInvoice
                    fullScreen={fullScreen}
                    isOpenModalDetailInvoice={isOpenModalDetailInvoice}
                    statusDetailInvoice={statusDetailInvoice}
                    closeModalDetailInvoice={closeModalDetailInvoice}
                    tanggalTransaksi={String(detailInvoice.tanggalTransaksi)}
                    nomorInvoice={String(detailInvoice.nomorInvoice)}
                    daftarItem={detailInvoice.daftarItem}
                    totalHarga={Number(detailInvoice.totalHarga)}
                    diskon={Number(detailInvoice.diskon)}
                    totalPembayaran={Number(detailInvoice.totalPembayaran)}
                    uangYangDibayar={Number(detailInvoice.uangYangDibayar)}
                    kembalian={Number(detailInvoice.kembalian)}
                    kasir={detailInvoice.kasir}
                    sales={detailInvoice.sales}
                    pajak={Number(detailInvoice.pajak)}
                    dpp={Number(detailInvoice.dpp)}
                    namaMetode={detailInvoice.metode}
                    keterangan={detailInvoice.keterangan}
                    encrypt={detailInvoice.encrypt}
                    noInvoice={detailInvoice.nomorInvoice}
                    ongkir={ongkir}
                    ketOngkir={ketOngkir}
                    customAmount={customAmount}
                    ketCustomAmount={ketCustomAmount}
                    jatuhTempo={jatuhTempo}
                    metodePelanggan={
                        customer.id
                            ? customer.nama
                            : detailInvoice.metodePelanggan
                    }
                />
            )}
            {detailInvoice && (
                <ModalRevertInvoice
                    diskon={Number(detailInvoice?.diskon)}
                    totalHarga={Number(detailInvoice?.totalHarga)}
                    totalTagihan={Number(detailInvoice?.totalPembayaran)}
                    uangDibayar={Number(detailInvoice?.uangYangDibayar)}
                    kembalian={Number(detailInvoice?.kembalian)}
                    refetchLaporan={() => {}}
                    refetchListInvoice={refetchListInvoice}
                    refetchProdukTerjual={() => {}}
                    refetchMutasiStok={() => {}}
                    refetchGrafikPenjualan={() => {}}
                    item={detailInvoice?.daftarItem}
                    statusItem={statusDetailInvoice}
                    invoiceId={detailInvoiceId}
                    isOpenModalRevertInvoice={isOpenModalRevertInvoice}
                    closeModalRevertInvoice={() =>
                        setIsOpenModalRevertInvoice(false)
                    }
                    customer={customer}
                    ongkir={detailInvoice.ongkir}
                    ketOngkir={detailInvoice.ketOngkir}
                    customAmount={detailInvoice.customAmount}
                    ketCustomAmount={detailInvoice.ketCustomAmount}
                    metodeId={metodeId}
                />
            )}
            {detailInvoicePO && (
                <ModalDetailInvoice
                    isPreOrder
                    fullScreen={fullScreen}
                    isOpenModalDetailInvoice={isOpenModalDetailInvoicePO}
                    statusDetailInvoice={statusDetailInvoicePO}
                    closeModalDetailInvoice={closeModalDetailInvoicePO}
                    tanggalTransaksi={String(detailInvoicePO.tanggalTransaksi)}
                    nomorInvoice={String(detailInvoicePO.nomorInvoice)}
                    daftarItem={detailInvoicePO.daftarItem}
                    totalHarga={Number(detailInvoicePO.totalHarga)}
                    diskon={Number(detailInvoicePO.diskon)}
                    totalPembayaran={Number(detailInvoicePO.totalPembayaran)}
                    uangYangDibayar={Number(detailInvoicePO.uangYangDibayar)}
                    kembalian={Number(detailInvoicePO.kembalian)}
                    kasir={detailInvoicePO.kasir}
                    sales={detailInvoicePO.sales}
                    pajak={Number(detailInvoicePO.pajak)}
                    namaMetode={detailInvoicePO.metode}
                    keterangan={detailInvoicePO.keterangan}
                    encrypt={detailInvoicePO.encrypt}
                    noInvoice={detailInvoicePO.nomorInvoice}
                    ongkir={detailInvoicePO.ongkir}
                    ketOngkir={detailInvoicePO.ketOngkir}
                    customAmount={detailInvoicePO.customAmount}
                    ketCustomAmount={detailInvoicePO.ketCustomAmount}
                    jatuhTempo={jatuhTempo}
                    metodePelanggan={
                        customer.id
                            ? customer.nama
                            : detailInvoicePO.metodePelanggan
                    }
                />
            )}
            {detailInvoicePO && (
                <ModalDeletePreOrder
                    isOpenModalHapusPreOrder={isOpenModalDeletePreOrder}
                    closeModalHapusPreOrder={closeModalDeletePreOrder}
                    namaPreOrder={detailInvoicePO?.nomorInvoice}
                    idPreOrder={detailInvoiceId}
                />
            )}
            {detailInvoicePO && (
                <ModalAccPO
                    isOpenModalAccPO={isOpenModalAccPO}
                    closeModalAccPO={closeModalAccPO}
                    namaPreOrder={detailInvoicePO?.nomorInvoice}
                    idPreOrder={detailInvoiceId}
                />
            )}
        </React.Fragment>
    );
};

export default CardInvoice;
